<dgx-components-panel
  *ngIf="quoteDetails"
  [border]="border"
  [dgxTestHook]="testHooks.Panel"
  [rounded]="rounded"
  [variant]="variant"
>
  <h2 class="mb-4 typog-h3 protection-confirmation-panel__title">
    {{ 'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TITLE' | translate }}
  </h2>

  <dgx-components-description-list>
    <dgx-components-description-list-item
      [data]="quoteDetails.brandName + ' ' + quoteDetails.applianceName"
      [dgxQmSanitise]="'encrypt'"
      [stacked]="true"
      [title]="'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_APPLIANCE' | translate"
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      [data]="quoteDetails.planNumber"
      [dgxQmSanitise]="'encrypt'"
      [dgxTestHook]="testHooks.Plan"
      [stacked]="true"
      [title]="
        'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_NUMBER' | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      [data]="quoteDetails.breakdownStartDate | dateFormat : 'dd MMM yyyy'"
      [leftIcon]="'calendar'"
      [rightIcon]="'check'"
      [stacked]="true"
      [title]="
        'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_POLICY_START_DATE' | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="quoteFirstPaymentValue !== quoteSubsequentPaymentValue"
      [data]="quoteFirstPaymentValue | quoteOfferPrice"
      [dgxQmSanitise]="'block'"
      [stacked]="true"
      [title]="firstPaymentTitle"
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="quotePaymentTaxValue === undefined; else paymentBreakdown"
      [data]="
        (isSinglePayment ? quotePaymentTotalValue : quoteSubsequentPaymentValue)
          | currencyFormat
      "
      [dgxQmSanitise]="'block'"
      [stacked]="true"
      [title]="paymentTermTitle"
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      [data]="
        paymentType
          ? (paymentType | dgxPaymentType)
          : (quoteDetails.preferredPaymentOption?.paymentType | dgxPaymentType)
      "
      [dgxQmSanitise]="'encrypt'"
      [stacked]="true"
      [title]="
        'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_METHOD'
          | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="quoteDetails.preferredPaymentOption?.preferredPaymentDay"
      [data]="
        formatWithOrdinal(
          quoteDetails.preferredPaymentOption?.preferredPaymentDay
        ) +
        ('CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE_SUFFIX'
          | translate)
      "
      [leftIcon]="'calendar'"
      [rightIcon]="'check'"
      [stacked]="true"
      [title]="
        'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_MONTHLY_PAYMENT_DATE'
          | translate
      "
      [variant]="'bordered'"
    />
  </dgx-components-description-list>

  <div class="protection-confirmation-panel__links">
    <dgx-cms-brand-terms-and-conditions [quotes]="quoteDetails" />

    <dgx-cms-brand-ipid
      *dgxFeatureEnabled="ipidFeature; and: isInsuranceContractType"
      [quotes]="quoteDetails"
    />
  </div>
</dgx-components-panel>

<ng-template #paymentBreakdown>
  <dgx-components-description-list-item
    [stacked]="true"
    [title]="paymentTermTitle"
  >
    <dgx-components-description-list>
      <dgx-components-description-list-item
        [data]="quotePaymentValue | currencyFormat"
        [dgxQmSanitise]="'block'"
        [stacked]="true"
        [title]="
          'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_PRICE' | translate
        "
        [variant]="'bordered'"
      />

      <dgx-components-description-list-item
        [data]="quotePaymentTaxValue | currencyFormat"
        [dgxQmSanitise]="'block'"
        [stacked]="true"
        [title]="'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_ITEM_TAX' | translate"
        [variant]="'bordered'"
      />

      <dgx-components-description-list-item
        [data]="quotePaymentTotalValue | currencyFormat"
        [dgxQmSanitise]="'block'"
        [stacked]="true"
        [title]="'CHECKOUT_PROTECTION_CONFIRMATION_PANEL_TOTAL' | translate"
        [variant]="'bordered'"
      />
    </dgx-components-description-list>
  </dgx-components-description-list-item>
</ng-template>
